import React from 'react';
import FeaturedWorks from '../components/FeaturedWorks.jsx';
import Availability from '../components/Availability.jsx';
import Blurb from '../components/Blurb.jsx';

export default function GameDev() {
  return (
    <>
      <h2 className="page-header">Game Development</h2>
      <Blurb>
        <p>
          I’ve been making games since I was a child, and I’ve spent more than
          ten years building them in earnest. That path runs from early hobby
          projects through jam titles, shipped games, prototypes, tools, and
          mods. The work below is a sample of that practice.
        </p>
      </Blurb>

      {/* Temporarily hidden while featured works are the focus.
      <section>
        <h2>Game Development</h2>
        <p>
          Selected game work including jam titles, shipped games, prototypes, tools, and media.
        </p>
        <div className="media-container">
          <div className="video-section">
            <h3>Showreel</h3>
            <video width="100%" controls loop poster="/assets/video_poster.png">
              <source src="/assets/gameplay_vid.mp4" type="video/mp4" />
            </video>
          </div>
          <div className="audio-section">
            <h3>Soundtrack Sample</h3>
            <audio controls>
              <source src="/assets/game_song.ogg" type="audio/ogg" />
            </audio>
          </div>
        </div>
      </section>
      */}

      <FeaturedWorks category="game-dev" title="Featured Game Dev Works" layout="rows" />

      <FeaturedWorks category="mods" title="Featured Mods" layout="rows" />

      <Availability />
    </>
  );
}


